import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ConsultaFormContainer from "../../../components/ConsultaFormContainer/ConsultaFormContainer";
import Container from "../../../components/Container/Container";
import SearchContainer from "../../../components/SearchContainer/SearchContainer";
import SearchInput from "../../../components/SearchInput/SearchInput";
import { useListManager } from "../../../contexts/list.manager";
import "./ConsultaAccessRoutes.css";
import { TbCornerUpRightDouble } from "react-icons/tb";
import { FormAccessRoutes } from "../FormAccessRoutes/FormAccessRoutes";
import { ListAccessRoutes } from "../ListAccessRoutes/ListAccessRoutes";
import { LuRoute } from "react-icons/lu";

export const ConsultaAccessRoutes = () => {
   const { lineSelected } = useListManager();
   const [search, setSearch] = useState("");
   const [filters, setFilters] = useState("");
   const navigate = useNavigate();
   const location = useLocation();
   const [refreshKey, setRefreshKey] = useState(0);

   useEffect(() => {
      if (location.state?.deletedId || location.state?.refresh) {
         setRefreshKey((k) => !k);
         navigate(location.pathname, { replace: true, state: {} });
      }
   }, [location.state, navigate, location.pathname]);

   return (
      <div className="consulta-container">
         <div className="search-list-wrapper">
            <SearchContainer
               icon={<LuRoute size={20} />}
               title="Rotas de Acesso"
               navigate="../cadastro-access-routes"
               buttonLabel="Adicionar Rota"
            >
               <SearchInput
                  value={search}
                  placeholder="Buscar Rota de Acesso"
                  onChange={({ target }) => setSearch(target.value)}
                  onKeyPress={(e) => e.key === "Enter" && setFilters(search)}
               />
            </SearchContainer>
            <Container>
               <ListAccessRoutes filters={filters} refreshKey={refreshKey} />
            </Container>
         </div>
         <ConsultaFormContainer>
            <FormAccessRoutes accessRoute={lineSelected} type="consulta" />
         </ConsultaFormContainer>
      </div>
   );
};
